module.exports = __webpack_public_path__ + "img/GODIVA_icon.f7722871.png";